import Config from "@/const/Config";
import { BaseApi } from "./BaseApi";
import {
  BelongsGroup, Flow, getGroupByUserIdReq, getGroupMemberReq, ManagedGroup, GroupWithMember,
  MstSyouninGroup, MstSyouninGroupUser, GroupWithPermissionForUser, HasPermissionForTargetUserReq, MstSyouninGroupReq, MstSyouninGroupRes, SyouninGroupOptions, SyouninUser, SyouninGroupDetail, SyouninGroupCreateReq
} from "@/types/SyouninGroup";

export class MstSyouninGroupsApi extends BaseApi {

  /**
  * 承認グループの承認者として登録するユーザーを検索します。（すでに他の承認グループに設定されているユーザーは除外されます）
  * @returns
  */
  public async getSelectableSyouninUserList(mstSyouninGroupId?: number): Promise<MstSyouninGroupUser[]> {
    try {
      const res = await this.post<MstSyouninGroupUser[]>(Config.API_URL + `/master/syounin_groups/get_selectable_syounin_user_list`, { 'mstSyouninGroupId': mstSyouninGroupId });
      return res.data
    } catch (e: any) {
      throw e;
    }
  }

  /**
  * 承認グループ、承認者、所属するユーザーを検索します
  * @returns
  */
  public async searchGroupAndUser(req: MstSyouninGroupReq): Promise<MstSyouninGroupRes[]> {
    try {
      const res = await this.get<MstSyouninGroupRes[]>(Config.API_URL + `/master/syounin_groups/search_groups_and_users`, req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /** 承認グループIDを指定して情報を取得します */
  public async getGroupById(mst_syounin_group_id: number): Promise<SyouninGroupDetail> {
    try {
      const res = await this.post<SyouninGroupDetail>(Config.API_URL + `/master/syounin_groups/get_group`, { 'id': mst_syounin_group_id });
      return res.data
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 承認グループを新規登録します
   * @param params
   * @returns
   */
  public async createSyouninGroup(params: SyouninGroupCreateReq): Promise<any> {
    try {
      return await this.post(Config.API_URL + `/master/syounin_groups/create`, params);
    } catch (e: any) {
      throw e;
    }
  }

  /** 承認グループを更新します */
  public async updateSyouninGroup(params: MstSyouninGroup): Promise<any> {
    try {
      return await this.post(Config.API_URL + `/master/syounin_groups/update_group`, params);
    } catch (e: any) {
      throw e;
    }
  }

  /** 承認グループを削除します */
  public async deleteSyouninGroup(mst_syounin_group_id: number): Promise<any> {
    try {
      return await this.delete(Config.API_URL + `/master/syounin_groups/remove_group`, { 'id': mst_syounin_group_id });
    } catch (e: any) {
      throw e;
    }
  }

  public async getAllOptions(): Promise<SyouninGroupOptions> {
    try {
      const res = await this.get<SyouninGroupOptions>(Config.API_URL + `/master/syounin_groups/options/all`);
      return res.data
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 特定の承認グループ（フロー）を取得します
   * @param targetId
   * @returns
   */
  public async getFlow(targetId: number, syouninType: number, userId: number): Promise<Flow[]> {
    const req = {
      targetId: targetId,
      syouninType: syouninType,
      userId: userId
    }
    try {
      const res = await this.post(Config.API_URL + `/master/syounin_groups/flow`, req);
      return res.data as Flow[];
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 申請の承認者を取得します
   * @param syouninType
   * @returns
   */
  public async getApprover(syouninType: number): Promise<Flow[]> {
    const req = {
      syouninType: syouninType
    }
    try {
      const res = await this.post(Config.API_URL + `/master/syounin_groups/approver`, req);
      return res.data as Flow[];
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 指定したユーザーの所属するグループを取得
   * @param req
   * @returns
   */
  public async getGroupByUserId(req: getGroupByUserIdReq) {
    try {
      const res = await this.post<BelongsGroup[]>(Config.API_URL + `/master/syounin_groups/get_by_user_id`, req)
      return res.data
    } catch (e: any) {
      throw e
    }
  }

  /**
   * 指定した承認者ユーザーが管轄するグループを取得
   * @param req
   * @returns
   */
  public async getGroupBySyouninUserId(req: getGroupByUserIdReq) {
    try {
      const res = await this.post<ManagedGroup[]>(Config.API_URL + `/master/syounin_groups/get_by_syounin_user_id`, req)
      return res.data
    } catch (e: any) {
      throw e
    }
  }

  /**
   * 指定した承認者ユーザーが管轄するグループを取得
   * @param req
   * @returns
   */
  public async getGroupMember(req: getGroupMemberReq) {
    try {
      const res = await this.post<GroupWithMember[]>(Config.API_URL + `/master/syounin_groups/group_member`, req)
      return res.data
    } catch (e: any) {
      throw e
    }
  }

  /** 承認グループに承認者・確認者を追加します */
  public async addSyouninUsers(params: MstSyouninGroup): Promise<any> {
    try {
      return await this.post(Config.API_URL + `/master/syounin_groups/add_syouninusers`, params);
    } catch (e: any) {
      throw e;
    }
  }

  /** 承認グループの承認者・確認者を更新します */
  public async updateSyouninUsers(params: MstSyouninGroupRes): Promise<SyouninUser[]> {
    try {
      const res = await this.post<SyouninUser[]>(Config.API_URL + `/master/syounin_groups/update_syouninusers`, params);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /** 承認グループの承認者・確認者を削除します */
  public async deleteSyouninUser(mstSyouninGroupSyouninUserId: number, mstSyouninGroupId: number): Promise<any> {
    try {
      return await this.delete(Config.API_URL + `/master/syounin_groups/remove_syouninuser`,
        {
          'mstSyouninGroupSyouninUserId': mstSyouninGroupSyouninUserId,
          'mstSyouninGroupId': mstSyouninGroupId
        }
      );
    } catch (e: any) {
      throw e;
    }
  }

  /** 承認グループの承認者・確認者を更新します */
  public async hasPermissionForTargetUser(req: HasPermissionForTargetUserReq) {
    try {
      const res = await this.post<GroupWithPermissionForUser[]>(Config.API_URL + `/master/syounin_groups/has_permissions`, req);
      return res.data
    } catch (e: any) {
      throw e;
    }
  }

  /** 承認グループの承認者・確認者を更新します */
  public async isSyouninUser(groupId: number, userId?: number) {
    try {
      const res = await this.post<boolean>(Config.API_URL + `/master/syounin_groups/is_syounin_user`, { groupId, userId });
      return res.data
    } catch (e: any) {
      throw e;
    }
  }

  /** 承認グループの承認者・確認者を更新します */
  public async isKakuninUser(groupId: number, userId?: number) {
    try {
      const res = await this.post<boolean>(Config.API_URL + `/master/syounin_groups/is_kakunin_user`, { groupId, userId });
      return res.data
    } catch (e: any) {
      throw e;
    }
  }
}
